/*
 *  This has been generated using the Synergy STDev tool.
 *  Any modifications will be lost after the next build
 */
import * as st from './STApp'
import { componentApi, loadTranslations } from 'common'


export class ExtractDataEditor {
  async GetRelatedBusinessObjects(boid : string, showAll : boolean) : Promise<st.RelatedBusinessObjectResponse> {
    return await componentApi.call('st', 'extract-data-editor', 'ExtractDataEditor', 'GetRelatedBusinessObjects', {
      boid,
      showAll,
    });
  }
  async GetBusinessObjectInfos(boids : Array<string>) : Promise<Array<st.BusinessObjectInfo>> {
    return await componentApi.call('st', 'extract-data-editor', 'ExtractDataEditor', 'GetBusinessObjectInfos', {
      boids,
    });
  }
  async GetPropertyList(boid : string, excludeMethodBound : boolean) : Promise<Array<st.BOPropertyInfo>> {
    return await componentApi.call('st', 'extract-data-editor', 'ExtractDataEditor', 'GetPropertyList', {
      boid,
      excludeMethodBound,
    });
  }
  async LoadExtractData(reportGu : string) : Promise<st.ExtractData> {
    return await componentApi.call('st', 'extract-data-editor', 'ExtractDataEditor', 'LoadExtractData', {
      reportGu,
    });
  }
  async SaveExtractData(extractDataGu : string, extractData : st.ExtractData) : Promise<st.ExtractData> {
    return await componentApi.call('st', 'extract-data-editor', 'ExtractDataEditor', 'SaveExtractData', {
      extractDataGu,
      extractData,
    });
  }
}
export default new ExtractDataEditor()
